import { setBlockAction } from 'actions/setBlockAction';
import { cloneBlock, Block } from '@chameleoncreator/creator-app';

function updateLegacyBlocksWithSId(store) {
  const { blocks } = store.getState();
  const blocksList = Object.values(blocks) as Block[];

  const topicBlocks = blocksList.filter(block => {
    return block.type.toLowerCase() === 'topic';
  });

  const interactionBlocks = blocksList.filter(block => {
    return block.type.toLowerCase() === 'interaction';
  });

  let topicBlocksSIdCounter = Math.max(
    ...topicBlocks.map(topicBlock => topicBlock?.props?.sId || 0)
  );

  let interactionBlocksSIdCounter = Math.max(
    ...interactionBlocks.map(
      interactionBlock => interactionBlock?.props?.sId || 0
    )
  );

  const blocksUpdatedWithSId = (blocks: Block[]) => {
    // filter out the blocks that HAVE sId
    return blocks
      .filter((block: Block) => {
        if (block.props) {
          const { sId } = block.props;
          return !sId;
        }
      })
      .map((block: Block) => {
        const nextBlock = cloneBlock(block);

        let sId;

        if (nextBlock.type.toLowerCase() === 'topic') {
          topicBlocksSIdCounter += 1;
          sId = topicBlocksSIdCounter;
        } else {
          interactionBlocksSIdCounter += 1;
          sId = interactionBlocksSIdCounter;
        }

        nextBlock.props = {
          ...nextBlock.props,
          sId,
        };

        return nextBlock;
      });
  };

  const updatedBlocks = [
    ...blocksUpdatedWithSId(topicBlocks),
    ...blocksUpdatedWithSId(interactionBlocks),
  ];

  if (!updatedBlocks.length) {
    return;
  }

  updatedBlocks.forEach((block: Block) => {
    if (block) {
      store.dispatch(setBlockAction(block));
    } else {
      console.log(`WTF. ${block} is not a block !?!?`);
    }
  });
}

export { updateLegacyBlocksWithSId };
